import { useMemo } from 'react';
import { useRouteDetails } from '@lp/features/RoutePlanner/hooks/useRouteDetails';
import { RouteTypeEnum } from '@/api/apis/route';

export const useRouteLegs = () => {
  const { legs: mainLegs } = useRouteDetails(RouteTypeEnum.Main);
  const { legs: dryRunLegs } = useRouteDetails(RouteTypeEnum.DryRun);

  return useMemo(() => {
    return [...mainLegs, ...dryRunLegs];
  }, [mainLegs, dryRunLegs]);
};
